var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFeatureEasyApply = function SvgFeatureEasyApply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: 1.25,
    d: "m12.293 8.056-.267.819h5.294c.08 0 .174.048.235.16.06.109.05.21.005.28l-.01.016-.01.017-6.725 11.875-.01.017-.008.017a.177.177 0 0 1-.075.081.337.337 0 0 1-.166.037c-.139 0-.308-.145-.267-.38l1.755-7.605.177-.765H6.926c-.196 0-.325-.137-.297-.349L7.85 2.901l.002-.015.002-.015c.01-.116.132-.246.294-.246h5.502c.13 0 .328.164.276.42l-1.634 5.011Z"
  })));
};
export default SvgFeatureEasyApply;